// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_k1-0";
export var optionCard = "_k1-1";